import React, { memo } from 'react';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-spiritual-900 py-16 md:py-24 relative" data-id="element-113">
      <div className="absolute inset-0 opacity-[0.03]" data-id="element-114">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-spiritual-400 rounded-full blur-3xl" data-id="element-115" />
      </div>

      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10" data-id="element-116">
        {/* Problem Identification */}
        <div className="text-center mb-12" data-id="element-117">
          <span className="inline-flex items-center gap-2 text-spiritual-400 font-body text-sm uppercase tracking-widest mb-4" data-id="element-118">
            <AlertTriangleIcon className="w-4 h-4" aria-hidden="true" data-id="element-119" />
            ¿Te suena familiar?
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-spiritual-100 leading-tight" data-id="element-120">
            Has hecho todo lo que te dijeron...{' '}
            <span className="text-gold-gradient" data-id="element-121">y nada funciona</span>
          </h2>
        </div>

        <div className="bg-spiritual-800/40 border border-spiritual-700/50 rounded-2xl p-6 md:p-10 mb-12" data-id="element-122">
          <p className="text-base md:text-lg text-spiritual-200 font-body leading-relaxed mb-6" data-id="element-123">
            Has hecho todo lo que te dijeron: estudiaste, trabajas más de 10
            horas al día y cuidas cada centavo. Pero cada vez que logras ahorrar
            un poco, surge un imprevisto. El coche se rompe, un familiar
            necesita ayuda o una deuda olvidada aparece de la nada.
          </p>
          <p className="text-base md:text-lg text-spiritual-300 font-body leading-relaxed font-bold italic" data-id="element-124">
            Sientes que el dinero tiene alas y que, en el fondo, naciste para
            "luchar" por la supervivencia, igual que lo hizo tu madre y tu
            abuela antes que ella.
          </p>
        </div>

        {/* Why What You Tried Didn't Work */}
        <div className="mb-6" data-id="element-125">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-spiritual-100 mb-8 text-center" data-id="element-126">
            ¿Por qué nada de lo que intentaste funcionó?
          </h3>

          <div className="space-y-4" data-id="element-127">
            <div className="flex items-start gap-4 bg-spiritual-800/30 border border-spiritual-700/30 rounded-xl p-5" data-id="element-128">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-129" />
              <p className="text-spiritual-200 font-body leading-relaxed" data-id="element-130">
                <strong className="text-spiritual-100" data-id="element-131">
                  Los cursos de finanzas tradicionales
                </strong>{' '}
                solo te enseñan a usar Excel, pero no sanan el miedo visceral
                que sientes a que el dinero se acabe.
              </p>
            </div>

            <div className="flex items-start gap-4 bg-spiritual-800/30 border border-spiritual-700/30 rounded-xl p-5" data-id="element-132">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-133" />
              <p className="text-spiritual-200 font-body leading-relaxed" data-id="element-134">
                <strong className="text-spiritual-100" data-id="element-135">
                  Las afirmaciones positivas
                </strong>{' '}
                de "soy millonaria" fallan porque tus células aún guardan la
                memoria del hambre y las carencias de tus ancestros.
              </p>
            </div>

            <div className="flex items-start gap-4 bg-spiritual-800/30 border border-spiritual-700/30 rounded-xl p-5" data-id="element-136">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-137" />
              <p className="text-spiritual-200 font-body leading-relaxed" data-id="element-138">
                <strong className="text-spiritual-100" data-id="element-139">
                  El ahorro extremo
                </strong>{' '}
                solo refuerza tu mentalidad de escasez, atrayendo por ley de
                correspondencia más situaciones de falta.
              </p>
            </div>

            <div className="flex items-start gap-4 bg-spiritual-800/30 border border-spiritual-700/30 rounded-xl p-5" data-id="element-140">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-141" />
              <p className="text-spiritual-200 font-body leading-relaxed" data-id="element-142">
                <strong className="text-spiritual-100" data-id="element-143">
                  Trabajar más horas
                </strong>{' '}
                solo te está agotando físicamente sin resolver el bloqueo
                energético que detiene tu flujo económico.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}